import { Slider } from "primereact/slider";
import styled from "styled-components";
import { SliderStyleProps } from "./slider.types";
import { setBackgroundColor, setFillColor } from "./slider.utils";

export const StyledSlider = styled(Slider)<SliderStyleProps>`
	&.p-slider {
		background: ${setBackgroundColor};
		border: 0 none;
		border-radius: ${({ rounded }) => (rounded ? "3px" : "0px")};
	}

	&.p-slider:hover {
		cursor: pointer;
	}

	.p-slider-range {
		background: ${setFillColor};
		border-radius: ${({ rounded }) => (rounded ? "3px" : "0px")};
	}

	.p-slider-handle {
		visibility: ${({ showHandle }) => (showHandle ? "visible" : "hidden")};
		background: ${setFillColor};
		border-radius: 50%;
		border-color: ${setFillColor};
		transition: background-color 0.2s, color 0.2s, border-color 0.2s, box-shadow 0.2s;
	}

	.p-slider-handle:focus {
		outline: 0 none;
		outline-offset: 0;
		box-shadow: 0 0 0 0.2rem ${setFillColor};
	}

	&.p-slider:not(.p-disabled) .p-slider-handle:hover {
		background: ${setFillColor};
		border-color: ${setFillColor};
	}

	.p-slider.p-slider-horizontal {
		height: 0.375rem;
	}
`;
